import React from "react";

import {
  Html,
  Image,
} from "../../../../../../../plugins/@whitespace/gatsby-theme-wordpress-basic/src/wsui/components";
import { useThemeProps } from "../../../../../../../wsui/base";
import ModuleWrapper from "../ModuleWrapper.jsx";

export default function ImageModule(props) {
  props = useThemeProps({ name: "MunicipioImageModule", props });
  let { module = {}, title, imageProps, ...restProps } = props;
  let modImageOptions = module?.modImageOptions;
  let modImageImage = modImageOptions?.modImageImage;

  if (!modImageImage) return null;

  // The module-specific caption should override the media-library caption.
  let caption = modImageOptions?.modImageCaption || modImageImage?.caption;
  let alt = modImageImage?.alt;
  let base64 = modImageImage?.base64;
  let credit = modImageImage?.credit;
  let height = modImageImage?.height;
  let linkTo = modImageOptions?.link?.url || modImageImage?.link?.url;
  let src = modImageImage?.src;
  let srcSet = modImageImage?.srcSet;
  let srcSetWebp = modImageImage?.srcSetWebp;
  let width = modImageImage?.width;

  if (!src) return null;

  return (
    <ModuleWrapper title={title} {...restProps}>
      <Image
        alt={alt}
        base64={base64}
        caption={<Html>{caption}</Html>}
        credit={credit}
        height={height}
        linkTo={linkTo}
        src={src}
        srcSet={srcSet}
        srcSetWebp={srcSetWebp}
        srcWebp={src}
        width={width}
        {...imageProps}
      />
    </ModuleWrapper>
  );
}
